import { render, staticRenderFns } from "./CartCoupon.vue?vue&type=template&id=b5da6510&"
import script from "./CartCoupon.vue?vue&type=script&lang=ts&"
export * from "./CartCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports